import {
  AppliesTo as GrpcAppliesTo,
  AppliesToType,
  Tag as GrpcTag,
  Translation as GrpcTranslation,
} from "../../../../gen/witbooking/backoffice/tags/v1/tag_api_pb";
import { Tag, TagAppliesTo, TagAppliesToType, TickerWithPosition } from "../../domain/Tag";
import { Translation } from "../../domain/Translation";

export const toTagDomainFromGrpc = (tag: GrpcTag): Tag => {
  const translations = tag.getTranslationsList().map(t => toTagTranslationDomainFromGrpc(t));
  const appliesTo = tag.getAppliestoList().map(a => toTagAppliesDomainFromGrpc(a));
  return Tag.of(tag.getId(), tag.getTicker(), translations, appliesTo);
};

export const toTagTranslationDomainFromGrpc = (translation: GrpcTranslation): Translation => {
  return Translation.of(translation.getLocale(), translation.getTranslation());
};

export const toTagAppliesDomainFromGrpc = (appliesTo: GrpcAppliesTo): TagAppliesTo => {
  const tickers = appliesTo
    .getTickersList()
    .map(t => TickerWithPosition.of(t.getTicker(), t.getPosition()));

  return TagAppliesTo.of(toTagAppliesToTypeDomainFromGrpc(appliesTo.getType()), tickers);
};

export const toTagAppliesToTypeDomainFromGrpc = (
  appliesToType: AppliesToType
): TagAppliesToType => {
  switch (appliesToType) {
    case AppliesToType.ACCOMMODATION:
      return "accommodation";
    case AppliesToType.EXTRA:
      return "extra";
    case AppliesToType.PACKAGE:
      return "package";
    case AppliesToType.PROPERTY:
      return "property";
    default:
      throw new Error("Invalid TagAppliesToType");
  }
};

export const toTagAppliesToTypeGrpcFromDomain = (
  appliesToType: TagAppliesToType
): AppliesToType => {
  switch (appliesToType) {
    case "accommodation":
      return AppliesToType.ACCOMMODATION;
    case "extra":
      return AppliesToType.EXTRA;
    case "package":
      return AppliesToType.PACKAGE;
    case "property":
      return AppliesToType.PROPERTY;
    default:
      throw new Error("Invalid TagAppliesToType");
  }
};
